import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/system/params',
    name: 'SystemParams',
    component: () => import('@/views/system/params.vue'),
    meta: {
      title: '参数配置',
      permission: 'system:params'
    }
  },
  {
    path: '/system/notice',
    name: 'SystemNotice',
    component: () => import('@/views/system/notice.vue'),
    meta: {
      title: '公告管理',
      permission: 'system:notice'
    }
  },
  {
    path: '/system/log',
    name: 'SystemLog',
    component: () => import('@/views/system/log.vue'),
    meta: {
      title: '操作日志',
      permission: 'system:log'
    }
  }
]

export default routes
